export default __webpack_public_path__ + "static/media/dropper.c00e959d.png";